// @ts-nocheck
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    SendTracking,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import cloneDeep from "lodash/cloneDeep";
// Valtech Custom Code
import { dispatchPurchaseEvent } from "@store/Framework/Services/AnalyticsService";

addToChainAfter(chain, SetCartStatus, props => {
    const { cartToUpdate } = props;

    const state = toToolkitApplicationState(props.getState());
    const signature = state.bunzl.pages.Signature.Signature;

    cartToUpdate.additionalEmails = signature?.customerEmail || cartToUpdate.additionalEmails;

    if (signature) {
        cartToUpdate.properties.signatureName = signature.customerName;
        cartToUpdate.properties.signatureEmail = signature?.customerEmail || "";
        cartToUpdate.properties.signatureBase64 = signature.customerSignature;
        cartToUpdate.properties.signatureTimestamp = signature.timestamp;
    }
});

replaceInChain(chain, SetCartStatus, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const notes = state.pages.checkoutShipping.editedCartNotes || cart.notes; // Valtech Custom Code

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
        ? "PendingPaymentValidation"
        : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        notes, // Valtech Custom Code
    };
});

replaceInChain(chain, SendTracking, props => {
    dispatchPurchaseEvent(props.cartToUpdate); // Valtech Custom Code
});
